module.exports = __webpack_public_path__ + "media/images/icon_calendar_black-a476f6e34ca48c846075d05d78730f01.svg";